/* Custom Stroke — Theme JS */

document.addEventListener('DOMContentLoaded', function () {

  /* NAV scroll behavior */
  const header = document.querySelector('.cs-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.style.background = window.scrollY > 60
        ? 'rgba(8,8,8,0.99)'
        : 'rgba(8,8,8,0.95)';
    }, { passive: true });
  }

  /* Mobile nav close on link click */
  const mobileNav = document.getElementById('cs-mobile-nav');
  if (mobileNav) {
    mobileNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileNav.classList.remove('open');
      });
    });
    /* Close on backdrop click */
    mobileNav.addEventListener('click', function (e) {
      if (e.target === mobileNav) mobileNav.classList.remove('open');
    });
  }

  /* Product card add button feedback */
  document.querySelectorAll('.cs-product-card__add').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const original = this.textContent;
      this.textContent = '✓';
      this.style.background = 'var(--cs-orange)';
      this.style.borderColor = 'var(--cs-orange)';
      this.style.color = 'var(--cs-black)';
      setTimeout(function () {
        btn.textContent = original;
        btn.style.background = '';
        btn.style.borderColor = '';
        btn.style.color = '';
      }, 2000);
    });
  });

  /* Active nav link */
  const currentPath = window.location.pathname;
  document.querySelectorAll('.cs-nav a').forEach(function (link) {
    if (link.getAttribute('href') === currentPath) {
      link.classList.add('active');
    }
  });

});
// Search
document.querySelectorAll('[aria-label="Search"]').forEach(btn => {
  btn.addEventListener('click', () => window.location.href = '/search');
});

// Cart
document.querySelectorAll('[aria-label="Cart"]').forEach(btn => {
  btn.addEventListener('click', () => window.location.href = '/cart');
});

// Account
document.querySelectorAll('[aria-label="Account"]').forEach(btn => {
  btn.addEventListener('click', () => window.location.href = '/account');
});